import { mrt, output, vec4 } from 'three/tsl';
import * as THREE from 'three/webgpu';

type N = any;

/** The scene pass's buffers besides the colour: normals for AO and velocity for TRAA. */
const EXTRAS = ['normal', 'velocity'];

/**
 * The scene pass's outputs (see SceneSurface). The normal and velocity buffers blend as each
 * material's colour does, instead of three.js's default for extra targets (no blending, so
 * every fragment replaced them). Opaque surfaces still replace them; additive effects write
 * nothing to them (additiveOutputs).
 */
export function sceneOutputs(outputs: Record<string, N>): N {
  const m: N = mrt(outputs);
  for (const name of EXTRAS) {
    if (name in outputs) m.setBlendMode(name, new THREE.BlendMode(THREE.MaterialBlending));
  }
  return m;
}

/**
 * Outputs for an additive effect in the scene pass (motes): its colour, and zero for the normal
 * and velocity buffers, which then keep the surface behind it. A drifting sprite used to stamp
 * its own normal and velocity over its whole quad, even where it added no light, and AO and
 * TRAA drew a dark, noisy square that followed it. Buffers the pass doesn't have are skipped.
 */
export function additiveOutputs(): N {
  return mrt({ output, normal: vec4(0), velocity: vec4(0) });
}
